// src/components/layout/mobile_Layout.jsx

import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import MobileHeader from "../mobile/Header";

function MobileLayout() {
  const [username, setUsername] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const stored = localStorage.getItem("user");

    if (!stored) {
      navigate("/login");
      return;
    }

    try {
      const user = JSON.parse(stored);

      // 최소한 id 가 있어야 로그인된 걸로 판단
      if (user && user.id) {
        setUsername(user.name || user.username || "");
      } else {
        navigate("/login");
      }
    } catch (e) {
      console.error("Failed to parse user from localStorage:", e);
      navigate("/login");
    }
  }, [navigate]);

  return (
    <div className="app-container min-h-screen w-full flex flex-col bg-gray-50 overflow-x-hidden">
      {/* 상단 모바일 헤더 */}
      <MobileHeader username={username} />

      {/* 본문 영역 */}
      <div className="flex-1 w-full overflow-x-hidden">
        {/* ⚠ index.mobile.css 에서 main.flex-1 을 기준으로 모바일 레이아웃을 잡고 있음 */}
        <main className="flex-1">
          {/* 모바일 공통 래퍼 (index.mobile.css 에 정의된 클래스들) */}
          <div className="mobile-page-root">
            <div className="mobile-page-root-inner mobile-bottom-spacing">
              {/* 실제 페이지들 (예: Sub.jsx, Info.jsx 등) 이 여기로 렌더링 */}
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default MobileLayout;
